const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * SCORM View
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('ScormView', ['$resource', 'appConfiguration', function($resource, appConfiguration) {

    return $resource(appConfiguration.apiUrl + '/learn/v3/scorm/:action/:contentid/for/:userid', null, {
      preview: {params: {action: 'preview', contentid: '', userid: ''}, method: 'GET', isArray: false},
      register: {params: {action: 'register', contentid: '', userid: ''}, method: 'POST', isArray: false},
      registration: {params: {action: 'registration', contentid: '', userid: ''}, method: 'GET', isArray: false},
      launch: {params: {action: 'launch', contentid: '', userid: ''}, method: 'POST', isArray: false}
    });
  }]);